<template>
    <div class="modal fade" id="modal-cancel" tabindex="-1" aria-labelledby="modalCancelLabel">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalCancelLabel">{{$t('account.cryptofx')}}</h5>
                    <button type="button" class="close" @click="hide">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="hide">{{$t('btn.close')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import $ from "jquery";

export default {
    name: "CancelModal",
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_CANCEL_MODAL, () => {
            this.show();
        });
    },
    methods: {
        show() {
            $("#modal-cancel").modal("show");
        },
        hide() {
            $("#modal-cancel").modal("hide");
        },
        cancel() {
            $("#modal-cancel").modal("hide");
        }
    },
};
</script>
<style>

</style>
